module.exports = __webpack_public_path__ + "img/regSuccess.5d8f7089.png";